var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid demand-form" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "page-tab" }, [
        _c(
          "a",
          {
            staticClass: "tab",
            class: { active: _vm.currentStep >= 1 },
            staticStyle: { cursor: "auto" },
            attrs: { href: "javascript:void(0)" },
          },
          [
            _c("span", { staticClass: "num" }, [_vm._v("01")]),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.i18n("DemandApply.ApplyData"))),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "tab",
            class: { active: _vm.currentStep >= 2 },
            staticStyle: { cursor: "auto" },
            attrs: { href: "javascript:void(0)" },
          },
          [
            _c("span", { staticClass: "num" }, [_vm._v("02")]),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.i18n("DemandApply.DemandData"))),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "tab",
            class: { active: _vm.currentStep >= 3 },
            staticStyle: { cursor: "auto" },
            attrs: { href: "javascript:void(0)" },
          },
          [
            _c("span", { staticClass: "num" }, [_vm._v("03")]),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.i18n("DemandApply.JobData"))),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "tab",
            class: { active: _vm.currentStep >= 4 },
            staticStyle: { cursor: "auto" },
            attrs: { href: "javascript:void(0)" },
          },
          [
            _c("span", { staticClass: "num" }, [_vm._v("04")]),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.i18n("DemandApply.DegreeRequirement"))),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "tab",
            class: { active: _vm.currentStep >= 5 },
            staticStyle: { cursor: "auto" },
            attrs: { href: "javascript:void(0)" },
          },
          [
            _c("span", { staticClass: "num" }, [_vm._v("05")]),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.i18n("DemandApply.ExperienceRequirement"))),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "tab-content" },
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            ;(_vm.manpowerDemandStatus = "New"),
                              handleSubmit(_vm.saveDemand)
                          },
                        },
                      },
                      [
                        _vm.currentStep === 1
                          ? _c("fieldset", [
                              _c("div", { staticClass: "tab-section tab-01" }, [
                                _c("div", { staticClass: "tab-name" }, [
                                  _c("div", { staticClass: "name-inner" }, [
                                    _c("span", [_vm._v("1")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n("DemandApply.ApplyData")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "table",
                                  { staticClass: "table table-bordered" },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "width-15 text-right",
                                            attrs: { id: "applyDate" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n("Basic.ApplyDate")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", { staticClass: "width-35" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$common.dateFormatter(
                                                  _vm.demandApply.ApplicantTime
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n("Basic.ApplyUser")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", { staticClass: "width-35" }, [
                                          _vm._v(
                                            _vm._s(_vm.demandApply.Applicant)
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n(
                                                  "Basic.ApplyDepartment"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("treeselect", {
                                                          attrs: {
                                                            options:
                                                              _vm.departmentOptions,
                                                            searchable: true,
                                                            "show-count": true,
                                                            "default-expand-level": 1,
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "option-label",
                                                                fn: function ({
                                                                  node,
                                                                  shouldShowCount,
                                                                  count,
                                                                  labelClassName,
                                                                  countClassName,
                                                                }) {
                                                                  return _c(
                                                                    "label",
                                                                    {
                                                                      class:
                                                                        labelClassName,
                                                                      attrs: {
                                                                        for: "count",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            node.label
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      shouldShowCount
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              class:
                                                                                countClassName,
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " (" +
                                                                                  _vm._s(
                                                                                    count
                                                                                  ) +
                                                                                  ") "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.demandApply
                                                                .DemandDepartmentGuid,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "DemandDepartmentGuid",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "demandApply.DemandDepartmentGuid",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v("職缺名稱 "),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "職缺名稱",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input", {
                                                          attrs: {
                                                            clearable: "",
                                                            type: "textarea",
                                                            rows: 3,
                                                            maxlength: "200",
                                                            placeholder:
                                                              "請輸入",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.demandApply
                                                                .ManpowerDemandName,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "ManpowerDemandName",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "demandApply.ManpowerDemandName",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.ResumeType"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "width-35" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "履歷類型",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                            attrs: {
                                                              placeholder:
                                                                "請選擇",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.demandApply
                                                                  .ResumeType,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.demandApply,
                                                                    "ResumeType",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "demandApply.ResumeType",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.resumeTypeOptions,
                                                            function (resume) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: resume.Type,
                                                                  attrs: {
                                                                    label:
                                                                      resume.Name,
                                                                    value:
                                                                      resume.Type,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.RecruitDeadline"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "width-35" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "招募期限",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-date-picker", {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            type: "date",
                                                            "value-format":
                                                              "yyyy-MM-dd",
                                                            "picker-options": {
                                                              disabledDate:
                                                                _vm.$common
                                                                  .disabledDateBeforeToday,
                                                            },
                                                            placeholder:
                                                              "yyyy-MM-DD",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.demandApply
                                                                .RecruitmentDeadline,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "RecruitmentDeadline",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "demandApply.RecruitmentDeadline",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.currentStep === 2
                          ? _c("fieldset", [
                              _c("div", { staticClass: "tab-section tab-02" }, [
                                _c("div", { staticClass: "tab-name" }, [
                                  _c("div", { staticClass: "name-inner" }, [
                                    _c("span", [_vm._v("2")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n("DemandApply.DemandData")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "table",
                                  { staticClass: "table table-bordered" },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-right",
                                            attrs: { id: "jobType" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.JobType"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .PositionProperty,
                                                        expression:
                                                          "demandApply.PositionProperty",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "全職",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply
                                                          .PositionProperty,
                                                        "全職"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "PositionProperty",
                                                          "全職"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.FullTime"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .PositionProperty,
                                                        expression:
                                                          "demandApply.PositionProperty",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "兼職",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply
                                                          .PositionProperty,
                                                        "兼職"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "PositionProperty",
                                                          "兼職"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.PartTime"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .PositionProperty,
                                                        expression:
                                                          "demandApply.PositionProperty",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "高階",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply
                                                          .PositionProperty,
                                                        "高階"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "PositionProperty",
                                                          "高階"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.HighLevel"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "Position.PositionName"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "職務名稱",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                            attrs: {
                                                              filterable: "",
                                                              "value-key":
                                                                "PositionCode",
                                                              placeholder:
                                                                "請選擇",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.positionValue,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.positionValue =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "positionValue",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.positionOptions,
                                                            function (
                                                              position
                                                            ) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: position.PositionCode,
                                                                  attrs: {
                                                                    label:
                                                                      position.PositionName,
                                                                    value:
                                                                      position,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n(
                                                  "DemandApply.DemandNumber"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: _vm.i18n(
                                                  "DemandApply.DemandNumber"
                                                ),
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input-number", {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            min: 1,
                                                            max: 99999,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.demandApply
                                                                .DemandNumber,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "DemandNumber",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "demandApply.DemandNumber",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger ml-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.DateOfAppointment"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _c("el-date-picker", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "date",
                                                "value-format": "yyyy-MM-dd",
                                                "picker-options": {
                                                  disabledDate:
                                                    _vm.$common
                                                      .disabledDateBeforeToday,
                                                },
                                                placeholder: "yyyy-MM-DD",
                                              },
                                              model: {
                                                value: _vm.demandApply.OnBoard,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.demandApply,
                                                    "OnBoard",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "demandApply.OnBoard",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.RecruitMethod"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm._l(
                                              _vm.recruitmentMethodOptions,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.RecruitmentMethodGuid,
                                                    staticClass:
                                                      "form-check form-check-inline",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-check-label",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.demandApply
                                                                  .ManpowerDemandRecruitmentMethod,
                                                              expression:
                                                                "\n                            demandApply.ManpowerDemandRecruitmentMethod\n                          ",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-check-input",
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            value: item,
                                                            checked:
                                                              Array.isArray(
                                                                _vm.demandApply
                                                                  .ManpowerDemandRecruitmentMethod
                                                              )
                                                                ? _vm._i(
                                                                    _vm
                                                                      .demandApply
                                                                      .ManpowerDemandRecruitmentMethod,
                                                                    item
                                                                  ) > -1
                                                                : _vm
                                                                    .demandApply
                                                                    .ManpowerDemandRecruitmentMethod,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  _vm
                                                                    .demandApply
                                                                    .ManpowerDemandRecruitmentMethod,
                                                                $$el =
                                                                  $event.target,
                                                                $$c =
                                                                  $$el.checked
                                                                    ? true
                                                                    : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = item,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      _vm.demandApply,
                                                                      "ManpowerDemandRecruitmentMethod",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      _vm.demandApply,
                                                                      "ManpowerDemandRecruitmentMethod",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  _vm.demandApply,
                                                                  "ManpowerDemandRecruitmentMethod",
                                                                  $$c
                                                                )
                                                              }
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.RecruitmentMethod
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm.recruitmentMethodOtherStatus
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        name: "招募方式描述",
                                                        rules: "required",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function ({
                                                              errors,
                                                            }) {
                                                              return [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    type: "textarea",
                                                                    rows: 3,
                                                                    maxlength:
                                                                      "100",
                                                                    "show-word-limit":
                                                                      "",
                                                                    placeholder:
                                                                      "請輸入招募方式",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.recruitmentMethodDescription,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.recruitmentMethodDescription =
                                                                          typeof $$v ===
                                                                          "string"
                                                                            ? $$v.trim()
                                                                            : $$v
                                                                      },
                                                                    expression:
                                                                      "recruitmentMethodDescription",
                                                                  },
                                                                }),
                                                                errors[0]
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              errors[0]
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.ContractType"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .ContractType,
                                                        expression:
                                                          "demandApply.ContractType",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "一般",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply
                                                          .ContractType,
                                                        "一般"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "ContractType",
                                                          "一般"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 一般 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .ContractType,
                                                        expression:
                                                          "demandApply.ContractType",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "競業禁止",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply
                                                          .ContractType,
                                                        "競業禁止"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "ContractType",
                                                          "競業禁止"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 競業禁止 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .ContractType,
                                                        expression:
                                                          "demandApply.ContractType",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "鐘點計時",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply
                                                          .ContractType,
                                                        "鐘點計時"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "ContractType",
                                                          "鐘點計時"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 鐘點計時 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .ContractType,
                                                        expression:
                                                          "demandApply.ContractType",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "定期合約",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply
                                                          .ContractType,
                                                        "定期合約"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "ContractType",
                                                          "定期合約"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 定期合約 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.currentStep === 3
                          ? _c("fieldset", [
                              _c("div", { staticClass: "tab-section tab-03" }, [
                                _c("div", { staticClass: "tab-name" }, [
                                  _c("div", { staticClass: "name-inner" }, [
                                    _c("span", [_vm._v("3")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n("DemandApply.JobData")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "table",
                                  { staticClass: "table table-bordered" },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-right",
                                            attrs: { id: "jobLocation" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.JobLocation"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "4" } },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                            attrs: {
                                                              multiple: "",
                                                              filterable: "",
                                                              "value-key":
                                                                "WorkPlaceGuid",
                                                              placeholder:
                                                                "請選擇",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.demandApply
                                                                  .ManpowerDemandWorkPlace,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.demandApply,
                                                                    "ManpowerDemandWorkPlace",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "demandApply.ManpowerDemandWorkPlace",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.workplaceOptions,
                                                            function (
                                                              workplace
                                                            ) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: workplace.WorkPlaceGuid,
                                                                  attrs: {
                                                                    label:
                                                                      workplace.WorkPlace,
                                                                    value:
                                                                      workplace,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger ml-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n(
                                                  "DemandApply.JobResponsibility"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                mode: "lazy",
                                                rules: "required",
                                                name: _vm.i18n(
                                                  "DemandApply.JobResponsibility"
                                                ),
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input", {
                                                          attrs: {
                                                            type: "textarea",
                                                            rows: 8,
                                                            "show-word-limit":
                                                              "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.demandApply
                                                                .WorkContent,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "WorkContent",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "demandApply.WorkContent",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger ml-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.Description"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                rows: 8,
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.demandApply.Description,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.demandApply,
                                                    "Description",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "demandApply.Description",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.ShiftType"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          _vm._l(
                                            _vm.shiftOptions,
                                            function (item) {
                                              return _c(
                                                "div",
                                                {
                                                  key: item.WorkShiftTypeGuid,
                                                  staticClass: "form-check",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.demandApply
                                                                .ManpowerDemandWorkShiftType,
                                                            expression:
                                                              "demandApply.ManpowerDemandWorkShiftType",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-check-input",
                                                        attrs: {
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          value: item,
                                                          checked:
                                                            Array.isArray(
                                                              _vm.demandApply
                                                                .ManpowerDemandWorkShiftType
                                                            )
                                                              ? _vm._i(
                                                                  _vm
                                                                    .demandApply
                                                                    .ManpowerDemandWorkShiftType,
                                                                  item
                                                                ) > -1
                                                              : _vm.demandApply
                                                                  .ManpowerDemandWorkShiftType,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.demandApply
                                                                  .ManpowerDemandWorkShiftType,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = item,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  _vm.$set(
                                                                    _vm.demandApply,
                                                                    "ManpowerDemandWorkShiftType",
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ])
                                                                  )
                                                              } else {
                                                                $$i > -1 &&
                                                                  _vm.$set(
                                                                    _vm.demandApply,
                                                                    "ManpowerDemandWorkShiftType",
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      )
                                                                  )
                                                              }
                                                            } else {
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "ManpowerDemandWorkShiftType",
                                                                $$c
                                                              )
                                                            }
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.WorkShiftType
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("el-input", {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      clearable: "",
                                                      maxlength: "200",
                                                      placeholder:
                                                        "請填寫詳細時段或排班資訊",
                                                    },
                                                    model: {
                                                      value:
                                                        item.WorkShiftTypeDescription,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "WorkShiftTypeDescription",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.WorkShiftTypeDescription",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n("DemandApply.Shifts")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply.Shift,
                                                        expression:
                                                          "demandApply.Shift",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.demandApply.Shift
                                                      )
                                                        ? _vm._i(
                                                            _vm.demandApply
                                                              .Shift,
                                                            null
                                                          ) > -1
                                                        : _vm.demandApply.Shift,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.demandApply
                                                              .Shift,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "Shift",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "Shift",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.demandApply,
                                                            "Shift",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.Require"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.BusinessTrip"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", { staticClass: "width-35" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .BusinessTrip,
                                                        expression:
                                                          "demandApply.BusinessTrip",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.demandApply
                                                          .BusinessTrip
                                                      )
                                                        ? _vm._i(
                                                            _vm.demandApply
                                                              .BusinessTrip,
                                                            null
                                                          ) > -1
                                                        : _vm.demandApply
                                                            .BusinessTrip,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.demandApply
                                                              .BusinessTrip,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "BusinessTrip",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "BusinessTrip",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.demandApply,
                                                            "BusinessTrip",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.Require"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n("DemandApply.Expat")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", { staticClass: "width-35" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .OverseasWork,
                                                        expression:
                                                          "demandApply.OverseasWork",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.demandApply
                                                          .OverseasWork
                                                      )
                                                        ? _vm._i(
                                                            _vm.demandApply
                                                              .OverseasWork,
                                                            null
                                                          ) > -1
                                                        : _vm.demandApply
                                                            .OverseasWork,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.demandApply
                                                              .OverseasWork,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "OverseasWork",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "OverseasWork",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.demandApply,
                                                            "OverseasWork",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.Require"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.ManagementResponsibility"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .ManagementResponsibility,
                                                        expression:
                                                          "demandApply.ManagementResponsibility",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.demandApply
                                                          .ManagementResponsibility
                                                      )
                                                        ? _vm._i(
                                                            _vm.demandApply
                                                              .ManagementResponsibility,
                                                            null
                                                          ) > -1
                                                        : _vm.demandApply
                                                            .ManagementResponsibility,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.demandApply
                                                              .ManagementResponsibility,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "ManagementResponsibility",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "ManagementResponsibility",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.demandApply,
                                                            "ManagementResponsibility",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.Require"
                                                        )
                                                      ) +
                                                      " (若勾選，請填寫管理人數) "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.demandApply
                                            .ManagementResponsibility
                                            ? _c(
                                                "div",
                                                { staticClass: "form-inline" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      rules: "required",
                                                      name: "管理人數",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "el-input-number",
                                                                {
                                                                  staticClass:
                                                                    "w-100",
                                                                  attrs: {
                                                                    min: 1,
                                                                    max: 99999,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .demandApply
                                                                        .ManagementNumber,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.demandApply,
                                                                          "ManagementNumber",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "demandApply.ManagementNumber",
                                                                  },
                                                                }
                                                              ),
                                                              _c("div", [
                                                                errors[0]
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              errors[0]
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 薪資類型 "),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                            attrs: {
                                                              "value-key":
                                                                "Guid",
                                                              placeholder:
                                                                "請選擇",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.salaryTypeValue,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.salaryTypeValue =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "salaryTypeValue",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.salaryTypeOptions,
                                                            function (
                                                              salaryType
                                                            ) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: salaryType.Guid,
                                                                  attrs: {
                                                                    label:
                                                                      salaryType.Name,
                                                                    value:
                                                                      salaryType,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _vm.salaryTypeValue &&
                                            _vm.salaryTypeValue.Code === "other"
                                              ? _c("ValidationProvider", {
                                                  attrs: { rules: "required" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .demandApply
                                                                      .SalaryTypeDescription,
                                                                  expression:
                                                                    "demandApply.SalaryTypeDescription",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "5px",
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                placeholder:
                                                                  "請填寫薪資類型",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .demandApply
                                                                    .SalaryTypeDescription,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      _vm.demandApply,
                                                                      "SalaryTypeDescription",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_vm._v("薪資待遇")]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md" },
                                                [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      tag: "section",
                                                      name: "薪資待遇(低)",
                                                      rules: {
                                                        regex: new RegExp(
                                                          /^([0-9,]+)$/
                                                        ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.trim",
                                                                    value:
                                                                      _vm
                                                                        .demandApply
                                                                        .SalaryLow,
                                                                    expression:
                                                                      "demandApply.SalaryLow",
                                                                    modifiers: {
                                                                      trim: true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control text-right",
                                                                attrs: {
                                                                  type: "text",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .demandApply
                                                                      .SalaryLow,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        _vm.demandApply,
                                                                        "SalaryLow",
                                                                        $event.target.value.trim()
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" ~ "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md" },
                                                [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      tag: "section",
                                                      name: "薪資待遇(高)",
                                                      rules: {
                                                        regex: new RegExp(
                                                          /^([0-9,]+)$/
                                                        ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.trim",
                                                                    value:
                                                                      _vm
                                                                        .demandApply
                                                                        .SalaryHigh,
                                                                    expression:
                                                                      "demandApply.SalaryHigh",
                                                                    modifiers: {
                                                                      trim: true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control text-right",
                                                                attrs: {
                                                                  type: "text",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .demandApply
                                                                      .SalaryHigh,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        _vm.demandApply,
                                                                        "SalaryHigh",
                                                                        $event.target.value.trim()
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _vm.demandApply.ResumeType === "DL"
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [_vm._v("預設職稱")]
                                            ),
                                            _c(
                                              "td",
                                              { attrs: { colspan: "3" } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.demandApply
                                                          .AppointmentDefaultPosition,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.demandApply,
                                                          "AppointmentDefaultPosition",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "demandApply.AppointmentDefaultPosition",
                                                    },
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "生產助理員",
                                                        value: "生產助理員",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "助理",
                                                        value: "助理",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "技術助理員",
                                                        value: "技術助理員",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "技術員",
                                                        value: "技術員",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "高級技術員",
                                                        value: "高級技術員",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "事務員",
                                                        value: "事務員",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "資深技術員",
                                                        value: "資深技術員",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "組長",
                                                        value: "組長",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "儲備組長",
                                                        value: "儲備組長",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "工讀生",
                                                        value: "工讀生",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "實習生",
                                                        value: "實習生",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "按摩師",
                                                        value: "按摩師",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.demandApply.ResumeType === "DL"
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [_vm._v("預設職等")]
                                            ),
                                            _c(
                                              "td",
                                              { attrs: { colspan: "3" } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.demandApply
                                                          .AppointmentDefaultRank,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.demandApply,
                                                          "AppointmentDefaultRank",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "demandApply.AppointmentDefaultRank",
                                                    },
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "1",
                                                        value: "1",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "2",
                                                        value: "2",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "2.1",
                                                        value: "2.1",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "2.2",
                                                        value: "2.2",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "3",
                                                        value: "3",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "4",
                                                        value: "4",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "5",
                                                        value: "5",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "6",
                                                        value: "6",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "6.3",
                                                        value: "6.3",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "7",
                                                        value: "7",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "7.3",
                                                        value: "7.3",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "8",
                                                        value: "8",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "8.3",
                                                        value: "8.3",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "9",
                                                        value: "9",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "9.3",
                                                        value: "9.3",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "10",
                                                        value: "10",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "10.3",
                                                        value: "10.3",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "10.5",
                                                        value: "10.5",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "10.7",
                                                        value: "10.7",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "11",
                                                        value: "11",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "11.3",
                                                        value: "11.3",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "11.5",
                                                        value: "11.5",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "12",
                                                        value: "12",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "13",
                                                        value: "13",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "13.3",
                                                        value: "13.3",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.demandApply.ResumeType === "DL"
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [_vm._v("預設薪資")]
                                            ),
                                            _c(
                                              "td",
                                              { attrs: { colspan: "3" } },
                                              [
                                                _c("ValidationProvider", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    name: "預設薪資",
                                                    rules: {
                                                      regex: new RegExp(
                                                        /^([0-9,]+)$/
                                                      ),
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.trim",
                                                                  value:
                                                                    _vm
                                                                      .demandApply
                                                                      .AppointmentDefaultSalary,
                                                                  expression:
                                                                    "demandApply.AppointmentDefaultSalary",
                                                                  modifiers: {
                                                                    trim: true,
                                                                  },
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control text-right",
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .demandApply
                                                                    .AppointmentDefaultSalary,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      _vm.demandApply,
                                                                      "AppointmentDefaultSalary",
                                                                      $event.target.value.trim()
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            errors
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          errors[0]
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 預設身份別 "),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: {
                                                name: "預設身份別",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                            attrs: {
                                                              clearable: "",
                                                              filterable: "",
                                                              placeholder:
                                                                "請選擇",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.demandApply
                                                                  .AppointmentDefaultIdentityType,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.demandApply,
                                                                    "AppointmentDefaultIdentityType",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "demandApply.AppointmentDefaultIdentityType",
                                                            },
                                                          },
                                                          [
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "IDL",
                                                                value: "IDL",
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label:
                                                                  "IDL工讀生",
                                                                value:
                                                                  "IDL工讀生",
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "DL",
                                                                value: "DL",
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "按摩師",
                                                                value: "按摩師",
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label:
                                                                  "DL產學合作4+2產學生(高中畢業)",
                                                                value:
                                                                  "DL產學合作4+2產學生(高中畢業)",
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label:
                                                                  "DL產學合作1年期實習生(大四學生)",
                                                                value:
                                                                  "DL產學合作1年期實習生(大四學生)",
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "外籍",
                                                                value: "外籍",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 職務聯絡人 "),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                            attrs: {
                                                              filterable: "",
                                                              "allow-create":
                                                                "",
                                                              clearable: "",
                                                              "value-key":
                                                                "Email",
                                                              placeholder:
                                                                "請選擇",
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.changeContactor,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.demandApply
                                                                  .PositionContactor,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.demandApply,
                                                                    "PositionContactor",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "demandApply.PositionContactor",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.contactorOptions,
                                                            function (
                                                              contactor
                                                            ) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: contactor.Email,
                                                                  attrs: {
                                                                    label:
                                                                      contactor.Name,
                                                                    value:
                                                                      contactor,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 聯絡人Email "),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input", {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            clearable: "",
                                                            maxlength: "200",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.demandApply
                                                                .PositionContactorEmail,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "PositionContactorEmail",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "demandApply.PositionContactorEmail",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.currentStep === 4
                          ? _c("fieldset", [
                              _c("div", { staticClass: "tab-section tab-05" }, [
                                _c("div", { staticClass: "tab-name" }, [
                                  _c("div", { staticClass: "name-inner" }, [
                                    _c("span", [_vm._v("4")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n(
                                            "DemandApply.DegreeRequirement"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "table",
                                  { staticClass: "table table-bordered" },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "width-15 text-right",
                                            attrs: { id: "degree" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n("DemandApply.Degree")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .EducationDemandWhatever,
                                                        expression:
                                                          "demandApply.EducationDemandWhatever",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.demandApply
                                                          .EducationDemandWhatever
                                                      )
                                                        ? _vm._i(
                                                            _vm.demandApply
                                                              .EducationDemandWhatever,
                                                            null
                                                          ) > -1
                                                        : _vm.demandApply
                                                            .EducationDemandWhatever,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.demandApply
                                                              .EducationDemandWhatever,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "EducationDemandWhatever",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "EducationDemandWhatever",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.demandApply,
                                                            "EducationDemandWhatever",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 不拘 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          !_vm.demandApply
                                            .EducationDemandWhatever
                                            ? _c(
                                                "div",
                                                [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules: "required",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            failed,
                                                          }) {
                                                            return [
                                                              _vm._l(
                                                                _vm.educationDegreeOptions,
                                                                function (
                                                                  item
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: item.Guid,
                                                                      staticClass:
                                                                        "form-check form-check-inline",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "form-check-label",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .demandApply
                                                                                        .ManpowerDemandEducationDegree,
                                                                                    expression:
                                                                                      "\n                                demandApply.ManpowerDemandEducationDegree\n                              ",
                                                                                  },
                                                                                ],
                                                                              staticClass:
                                                                                "form-check-input",
                                                                              attrs:
                                                                                {
                                                                                  type: "checkbox",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    item,
                                                                                  checked:
                                                                                    Array.isArray(
                                                                                      _vm
                                                                                        .demandApply
                                                                                        .ManpowerDemandEducationDegree
                                                                                    )
                                                                                      ? _vm._i(
                                                                                          _vm
                                                                                            .demandApply
                                                                                            .ManpowerDemandEducationDegree,
                                                                                          item
                                                                                        ) >
                                                                                        -1
                                                                                      : _vm
                                                                                          .demandApply
                                                                                          .ManpowerDemandEducationDegree,
                                                                                },
                                                                              on: {
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    var $$a =
                                                                                        _vm
                                                                                          .demandApply
                                                                                          .ManpowerDemandEducationDegree,
                                                                                      $$el =
                                                                                        $event.target,
                                                                                      $$c =
                                                                                        $$el.checked
                                                                                          ? true
                                                                                          : false
                                                                                    if (
                                                                                      Array.isArray(
                                                                                        $$a
                                                                                      )
                                                                                    ) {
                                                                                      var $$v =
                                                                                          item,
                                                                                        $$i =
                                                                                          _vm._i(
                                                                                            $$a,
                                                                                            $$v
                                                                                          )
                                                                                      if (
                                                                                        $$el.checked
                                                                                      ) {
                                                                                        $$i <
                                                                                          0 &&
                                                                                          _vm.$set(
                                                                                            _vm.demandApply,
                                                                                            "ManpowerDemandEducationDegree",
                                                                                            $$a.concat(
                                                                                              [
                                                                                                $$v,
                                                                                              ]
                                                                                            )
                                                                                          )
                                                                                      } else {
                                                                                        $$i >
                                                                                          -1 &&
                                                                                          _vm.$set(
                                                                                            _vm.demandApply,
                                                                                            "ManpowerDemandEducationDegree",
                                                                                            $$a
                                                                                              .slice(
                                                                                                0,
                                                                                                $$i
                                                                                              )
                                                                                              .concat(
                                                                                                $$a.slice(
                                                                                                  $$i +
                                                                                                    1
                                                                                                )
                                                                                              )
                                                                                          )
                                                                                      }
                                                                                    } else {
                                                                                      _vm.$set(
                                                                                        _vm.demandApply,
                                                                                        "ManpowerDemandEducationDegree",
                                                                                        $$c
                                                                                      )
                                                                                    }
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                item.EducationDegree
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              failed
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger ml-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " 請選擇學歷要求 "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n("DemandApply.Major")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _vm._l(
                                              _vm.demandApply
                                                .ManpowerDemandSchoolDepartment,
                                              function (majorItem, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticStyle: {
                                                      "margin-bottom": "20px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "language-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              majorItem.SchoolDepartmentType
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "h6",
                                                      {
                                                        staticStyle: {
                                                          "margin-bottom":
                                                            "12px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  majorItem.SchoolDepartment
                                                                    ? majorItem.SchoolDepartment
                                                                    : null
                                                                ) +
                                                                " "
                                                            ),
                                                            majorItem.SchoolDepartmentDescription
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " ｜科系描述：" +
                                                                      _vm._s(
                                                                        majorItem.SchoolDepartmentDescription
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn btn-danger btn-sm",
                                                                attrs: {
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.deleteItem(
                                                                        index,
                                                                        "Education"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("eva-icon", {
                                                                  attrs: {
                                                                    fill: "#FFF",
                                                                    name: "trash-2-outline",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c(
                                              "div",
                                              [
                                                _vm.addMajor
                                                  ? _c("AddMajor", {
                                                      on: {
                                                        addMajor: _vm.saveItem,
                                                        addCancel: function (
                                                          $event
                                                        ) {
                                                          return _vm.cancelItem(
                                                            "Education"
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-sm",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.addItem(
                                                              "Education"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-plus",
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.i18n(
                                                                "DemandApply.Major"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.Language"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _vm._l(
                                              _vm.demandApply
                                                .ManpowerDemandLanguage,
                                              function (languageItem, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticStyle: {
                                                      "margin-bottom": "20px",
                                                    },
                                                  },
                                                  [
                                                    languageItem.LanguageDescription
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  languageItem.LanguageDescription
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  languageItem.Language
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                    _c(
                                                      "h6",
                                                      {
                                                        staticStyle: {
                                                          "margin-bottom":
                                                            "12px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n(
                                                                  "Language.Listen"
                                                                )
                                                              ) +
                                                                "：" +
                                                                _vm._s(
                                                                  languageItem.Listen
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v("｜ "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n(
                                                                  "Language.Speak"
                                                                )
                                                              ) +
                                                                "：" +
                                                                _vm._s(
                                                                  languageItem.Speak
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v("｜ "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n(
                                                                  "Language.Read"
                                                                )
                                                              ) +
                                                                "：" +
                                                                _vm._s(
                                                                  languageItem.Read
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v("｜ "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n(
                                                                  "Language.Write"
                                                                )
                                                              ) +
                                                                "：" +
                                                                _vm._s(
                                                                  languageItem.Write
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-danger btn-sm",
                                                            attrs: {
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteItem(
                                                                  index,
                                                                  "Language"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("eva-icon", {
                                                              attrs: {
                                                                fill: "#FFF",
                                                                name: "trash-2-outline",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm.addLanguage
                                              ? _c("AddLanguage", {
                                                  on: {
                                                    addLanguage: _vm.saveItem,
                                                    addCancel: function (
                                                      $event
                                                    ) {
                                                      return _vm.cancelItem(
                                                        "Language"
                                                      )
                                                    },
                                                  },
                                                })
                                              : _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addItem(
                                                          "Language"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-plus",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.i18n(
                                                            "DemandApply.Language"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "DemandApply.Dialect"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _vm._l(
                                              _vm.demandApply
                                                .ManpowerDemandDialect,
                                              function (dialectItem, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticStyle: {
                                                      "margin-bottom": "20px",
                                                    },
                                                  },
                                                  [
                                                    dialectItem.DialectDescription
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  dialectItem.DialectDescription
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  dialectItem.Dialect
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                    _c(
                                                      "h6",
                                                      {
                                                        staticStyle: {
                                                          "margin-bottom":
                                                            "12px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " 程度： " +
                                                                _vm._s(
                                                                  dialectItem.Degree
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-danger btn-sm",
                                                            attrs: {
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteItem(
                                                                  index,
                                                                  "Dialect"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("eva-icon", {
                                                              attrs: {
                                                                fill: "#FFF",
                                                                name: "trash-2-outline",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm.addDialect
                                              ? _c("AddDialect", {
                                                  on: {
                                                    addDialect: _vm.saveItem,
                                                    addCancel: function (
                                                      $event
                                                    ) {
                                                      return _vm.cancelItem(
                                                        "Dialect"
                                                      )
                                                    },
                                                  },
                                                })
                                              : _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addItem(
                                                          "Dialect"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-plus",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.i18n(
                                                            "DemandApply.Dialect"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.currentStep === 5
                          ? _c("fieldset", [
                              _c("div", { staticClass: "tab-section tab-04" }, [
                                _c("div", { staticClass: "tab-name" }, [
                                  _c("div", { staticClass: "name-inner" }, [
                                    _c("span", [_vm._v("5")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n(
                                            "DemandApply.ExperienceRequirement"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "table",
                                  { staticClass: "table table-bordered" },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              id: "experience",
                                              colspan: "1",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 工作經驗 "),
                                          ]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .WorkExperienceWhatever,
                                                        expression:
                                                          "demandApply.WorkExperienceWhatever",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.demandApply
                                                          .WorkExperienceWhatever
                                                      )
                                                        ? _vm._i(
                                                            _vm.demandApply
                                                              .WorkExperienceWhatever,
                                                            null
                                                          ) > -1
                                                        : _vm.demandApply
                                                            .WorkExperienceWhatever,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.demandApply
                                                              .WorkExperienceWhatever,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "WorkExperienceWhatever",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "WorkExperienceWhatever",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.demandApply,
                                                            "WorkExperienceWhatever",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 不拘 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          !_vm.demandApply
                                            .WorkExperienceWhatever
                                            ? _c(
                                                "div",
                                                { staticClass: "form-inline" },
                                                [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "年資要求",
                                                      rules: "required",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _vm._v(
                                                                " 年資要求： "
                                                              ),
                                                              _c(
                                                                "el-input-number",
                                                                {
                                                                  staticClass:
                                                                    "w-100",
                                                                  attrs: {
                                                                    min: 1,
                                                                    max: 99,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .demandApply
                                                                        .WorkExperience,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.demandApply,
                                                                          "WorkExperience",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "demandApply.WorkExperience",
                                                                  },
                                                                }
                                                              ),
                                                              errors[0]
                                                                ? _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            errors[0]
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [_vm._v("年齡")]
                                        ),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply
                                                            .AgeRangeWhatever,
                                                        expression:
                                                          "demandApply.AgeRangeWhatever",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.demandApply
                                                          .AgeRangeWhatever
                                                      )
                                                        ? _vm._i(
                                                            _vm.demandApply
                                                              .AgeRangeWhatever,
                                                            null
                                                          ) > -1
                                                        : _vm.demandApply
                                                            .AgeRangeWhatever,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.demandApply
                                                              .AgeRangeWhatever,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "AgeRangeWhatever",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.demandApply,
                                                                "AgeRangeWhatever",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.demandApply,
                                                            "AgeRangeWhatever",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 不拘 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          !_vm.demandApply.AgeRangeWhatever
                                            ? _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md" },
                                                    [
                                                      _c("ValidationProvider", {
                                                        attrs: {
                                                          tag: "section",
                                                          name: "年齡(最低)",
                                                          rules: "required",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                errors,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "el-input-number",
                                                                    {
                                                                      staticClass:
                                                                        "w-100",
                                                                      attrs: {
                                                                        min: 18,
                                                                        max: 80,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .demandApply
                                                                            .AgeRangeStart,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.demandApply,
                                                                              "AgeRangeStart",
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "demandApply.AgeRangeStart",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          errors[0]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" ~ "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md" },
                                                    [
                                                      _c("ValidationProvider", {
                                                        attrs: {
                                                          tag: "section",
                                                          name: "年齡(最高)",
                                                          rules: "required",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                errors,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "el-input-number",
                                                                    {
                                                                      staticClass:
                                                                        "w-100",
                                                                      attrs: {
                                                                        min: 18,
                                                                        max: 80,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .demandApply
                                                                            .AgeRangeEnd,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.demandApply,
                                                                              "AgeRangeEnd",
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "demandApply.AgeRangeEnd",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          errors[0]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_vm._v("性別")]
                                        ),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply.Sex,
                                                        expression:
                                                          "demandApply.Sex",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "不拘",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply.Sex,
                                                        "不拘"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "Sex",
                                                          "不拘"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 不拘 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply.Sex,
                                                        expression:
                                                          "demandApply.Sex",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "男",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply.Sex,
                                                        "男"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "Sex",
                                                          "男"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 男 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-check form-check-inline",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.demandApply.Sex,
                                                        expression:
                                                          "demandApply.Sex",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "女",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.demandApply.Sex,
                                                        "女"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.demandApply,
                                                          "Sex",
                                                          "女"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" 女 "),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_vm._v("駕照")]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _c("el-cascader", {
                                              staticClass: "w-100",
                                              attrs: {
                                                options:
                                                  _vm.driverLicenseOptions,
                                                clearable: "",
                                                filterable: "",
                                                props: _vm.props,
                                                "show-all-levels": false,
                                              },
                                              on: {
                                                change:
                                                  _vm.driverLicensesChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.manpowerDemandDriverLicense,
                                                callback: function ($$v) {
                                                  _vm.manpowerDemandDriverLicense =
                                                    $$v
                                                },
                                                expression:
                                                  "manpowerDemandDriverLicense",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_vm._v("證照")]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _c("el-cascader", {
                                              staticClass: "w-100",
                                              attrs: {
                                                options: _vm.certificateOptions,
                                                clearable: "",
                                                filterable: "",
                                                props: _vm.props,
                                                "show-all-levels": false,
                                                "filter-method":
                                                  _vm.certificationsFilter,
                                              },
                                              on: {
                                                change:
                                                  _vm.certificationsChange,
                                              },
                                              model: {
                                                value: _vm.chooseCertifications,
                                                callback: function ($$v) {
                                                  _vm.chooseCertifications = $$v
                                                },
                                                expression:
                                                  "chooseCertifications",
                                              },
                                            }),
                                            _vm.certificateOther
                                              ? _c("ValidationProvider", {
                                                  attrs: {
                                                    tag: "section",
                                                    rules: "required",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.certificateDescription,
                                                                  expression:
                                                                    "certificateDescription",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control mt-2",
                                                              attrs: {
                                                                rows: "5",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.certificateDescription,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.certificateDescription =
                                                                      $event.target.value
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_vm._v("其他條件")]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                rows: 6,
                                                maxlength: "500",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.demandApply
                                                    .OtherConditions,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.demandApply,
                                                    "OtherConditions",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "demandApply.OtherConditions",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "button-wrap center" }, [
                          _vm.currentStep !== 1
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      _vm.currentStep -= 1
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.i18n("Buttons.Back")) + " "
                                  ),
                                ]
                              )
                            : _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "modal",
                                    "data-target": "#historyModal",
                                  },
                                  on: {
                                    click: function ($event) {
                                      if (
                                        $event.target !== $event.currentTarget
                                      )
                                        return null
                                      ;(_vm.selectedDemand = null),
                                        _vm.$refs.historyDemand.reset()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.i18n("Buttons.CopyDemandData")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              staticStyle: { "margin-left": "5px" },
                              attrs: { type: "submit" },
                            },
                            [
                              _vm.currentStep !== 5
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.i18n("Buttons.Next"))),
                                  ])
                                : _vm._e(),
                              _vm.currentStep === 5
                                ? _c("span", [_vm._v("儲存")])
                                : _vm._e(),
                            ]
                          ),
                          _vm.currentStep === 5
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-info",
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.manpowerDemandStatus = "Pending"),
                                        _vm.saveDemand()
                                    },
                                  },
                                },
                                [_vm._v(" 送出 ")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "historyModal",
            "data-focus": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
            [
              _c(
                "div",
                { staticClass: "modal-content" },
                [
                  _c("ValidationObserver", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ handleSubmit }) {
                          return [
                            _c("div", { staticClass: "modal-header" }, [
                              _c("h6", { staticClass: "modal-title" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.i18n("DemandApply.HistoryDemand")
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "modal-body",
                                staticStyle: { height: "250px" },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-10" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "historyDemand",
                                        staticClass: "w-100",
                                        attrs: {
                                          name: _vm.i18n(
                                            "DemandApply.HistoryDemand"
                                          ),
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        filterable: "",
                                                        "value-key":
                                                          "ManpowerDemandNo",
                                                        placeholder: "請選擇",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedDemand,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.selectedDemand =
                                                            $$v
                                                        },
                                                        expression:
                                                          "selectedDemand",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.demandHistoryOptions,
                                                      function (demand) {
                                                        return _c("el-option", {
                                                          key: demand.ManpowerDemandNo,
                                                          attrs: {
                                                            label:
                                                              demand.ManpowerDemandNo +
                                                              " " +
                                                              demand.PositionName,
                                                            value: demand,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "col-md-2" }, [
                                    _vm.selectedDemand
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$store.commit(
                                                  "OpenDemandDetailModal",
                                                  _vm.selectedDemand
                                                    .ManpowerDemandNo
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.i18n("Buttons.View")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ]
                            ),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    type: "button",
                                    "data-dismiss": "modal",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n("Buttons.Cancel")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(
                                        _vm.getHistoryDemandDetail
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n("Buttons.Confirm")) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("DemandDetailModal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }